module.exports = __webpack_public_path__ + "static/media/bg_mobile.eaf29025.mp4";